import { isFunction } from "lodash";
import { MdKeyboardBackspace } from "react-icons/md";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  buttonText = "Suivant",
  disabled = false,
  buttonWidth = 366,
  icon,
  loading,
}) => {
  return (
    <div className="amellis__actions">
      {isFunction(onBack) && (
        <span className="amellis__actions--icon">
          <MdKeyboardBackspace onClick={onBack} />
        </span>
      )}
      {isFunction(onNext) && (
        <Button
          type="primary"
          width={buttonWidth}
          alignment="center"
          disabled={disabled}
          onClick={onNext}
          loading={loading}
          className={icon ? "has-icon" : ""}
          icon={icon}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
